<template>
  <div>
    <div class="mb-2">
      <v-text-input
        id="research-form-title"
        v-model="formData.title"
        label="word.title"
        :errors="errors.title"
        :required="true"
      />
    </div>

    <div class="mb-2">
      <v-text-area
        id="research-form-description"
        v-model="formData.description"
        label="word.description"
      />
    </div>

    <div class="mb-2" v-if="allowPublished">
      <v-date-picker
        id="research-form-published-at"
        v-model="formData.published_at"
        :errors="errors.published_at"
        label="phrase.published_at"
        :small="true"
        :max-date="new Date()"
        :required="true"
      />
    </div>

    <div class="mb-3" v-if="allowCreatedBy">
      <v-text-input
        id="register-research-supplier"
        label="word.supplier_name"
        help-text="sentence.supplier_text"
        v-model="formData.created_by_name"
      />
    </div>

    <div class="mb-2" v-if="allowCategories">
      <v-multi-select
        id="register-research-categories"
        v-if="categories"
        label="word.categories"
        placeholder="word.categories"
        help-text="phrase.multiple_categories"
        :errors="errors.category_ids"
        v-model="formData.categories"
        :options="categories"
        :disabled="categories.length === 0"
      />
    </div>
  </div>
</template>

<script>
import TextInput from '@/common/components/inputs/TextInput.vue';
import TextArea from '@/common/components/inputs/TextArea.vue';
import DatePicker from '@/common/components/inputs/DatePicker.vue';
import { fetchCommercialCategories } from '@/organisation/api';
import MultiSelect from '@/common/components/inputs/MultiSelectLib.vue';

export default {
  name: 'ResearchForm',
  components: {
    'v-text-input': TextInput,
    'v-text-area': TextArea,
    'v-multi-select': MultiSelect,
    'v-date-picker': DatePicker,
  },
  props: {
    allowCategories: {
      type: Boolean,
      required: false,
      default: false,
    },
    allowCreatedBy: {
      type: Boolean,
      required: false,
      default: false,
    },
    allowPublished: {
      type: Boolean,
      required: false,
      default: false,
    },
    formData: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loader: { loading: false },
      categories: null,
    };
  },
  methods: {
    async getCommercialCategories() {
      const response = await fetchCommercialCategories();
      this.categories = response.data.map((el) => ({
        id: el.id,
        name: el.name,
      }));
    },
  },
  created() {
    if (this.allowCategories) {
      this.getCommercialCategories();
    }
  },
};
</script>
